import ModalUploadImages from './ModalUploadImages'

export default ModalUploadImages